import { UNIT_TABS, type UnitTab } from '../units.paths';

/**
 * Where a truck's or trailer's old address (`/fleet/trucks/:id/<tab>`, `/fleet/trailers/:id/<tab>`) lands on its unit: the old
 * Trailer and Coupling tabs are the unit's coupling history; any other tab the unit has is kept.
 */
export function legacyUnitTab(tab: string | undefined): UnitTab {
  if (tab === 'trailer' || tab === 'coupling') return 'couplings';
  return (UNIT_TABS as readonly string[]).includes(tab ?? '') ? (tab as UnitTab) : 'details';
}
